export default __webpack_public_path__ + "static/media/legend.5e59edbd.svg";